import type {
  CreateTournamentTemplateRequest,
  TournamentTemplate,
  UpdateTournamentTemplateRequest,
} from '@swiss-magic/shared-types';
import { del, get, patch, post } from './core';

// Story 078 — director-private tournament templates. All four
// routes are auth-required; the JWT identifies the director.

export function listTemplates(): Promise<TournamentTemplate[]> {
  return get('/templates');
}

export function createTemplate(
  input: CreateTournamentTemplateRequest,
): Promise<TournamentTemplate> {
  return post('/templates', input);
}

export function renameTemplate(
  id: string,
  input: UpdateTournamentTemplateRequest,
): Promise<TournamentTemplate> {
  return patch(`/templates/${id}`, input);
}

export function deleteTemplate(id: string): Promise<void> {
  return del(`/templates/${id}`);
}
